export default {
  root: { width: '800px', backgroundColor: '#FFFFFF' },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center'
  }
};
